import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Empty, Pagination, Spin } from 'antd';
import { TransportedContentCard } from './TransportedContentCard';

export const TransportedView = (props) => {
  const { items = null, pagination, onPageChange } = props;

  const paginatedItems = useMemo(() => {
    if (!items || !Array.isArray(items)) return [];

    const { currentPage, pageSize } = pagination;
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    return items?.slice(startIndex, endIndex);
  }, [items, pagination]);

  const MemoizedCard = React.memo(TransportedContentCard);

  return (
    <div>
      {items && Array.isArray(items) && items.length > 0 ? (
        <>
          <div>
            {paginatedItems.map((item, index) => (
              <MemoizedCard key={item.id || index} item={item} />
            ))}
          </div>

          <div
            style={{
              textAlign: 'center',
              marginTop: '20px',
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: 'white',
              borderRadius: '8px',
            }}
          >
            <Pagination
              current={pagination.currentPage}
              pageSize={pagination.pageSize}
              total={items.length}
              onChange={onPageChange}
              showSizeChanger
              pageSizeOptions={['5', '10', '20', '50']}
              showTotal={(total) => `ทั้งหมด ${total} รายการ`}
            />
          </div>
        </>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </div>
  );
};

TransportedView.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      productImageUrl: PropTypes.string,
      claimCode: PropTypes.string,
      warrantyCode: PropTypes.string,
      mobileModelName: PropTypes.string,
      productName: PropTypes.string,
      expireDate: PropTypes.string,
      fullName: PropTypes.string,
      telephone: PropTypes.string,
      claimStatusName: PropTypes.string,
      claimStatus: PropTypes.string,
      shippingName: PropTypes.string,
      trackingNumber: PropTypes.string,
    }),
  ),
};

TransportedView.defaultProps = {
  items: [],
};
